import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectTooltipInfo = () => createSelector(substate, (contextState) => contextState.tooltipInfo);
